import React from "react";
import "./WitEarnHome.scss"
import ResourcesCard from "../../components/ResourcesCard/ResourcesCard";
import SecondaryButton from "../../components/Button/SecondaryButton";
import { sortByOrderAscending } from "../../helper/helper";

const WitEarnHomeResources = ({ components }) => {
    const getComponents = (key, component) => {
        switch (component.ID) {
            case "HeaderText":
                return <div className="WitEarnHomeResources-header">
                    {component?.Props?.text}
                </div>
            case "HeaderSubText":
                return <div className="WitEarnHomeResources-subheader">
                    {component?.Props?.text}
                </div>
            case "WitEarnHomeResourcesGrid":
                return <div className="WitEarnHomeResources-grid">
                    {component?.Data?.map((resource, key) => {
                        return <ResourcesCard key={key} header={resource.header} subheader={resource.subheader} icon={resource.icon} iconColor={resource.iconColor} />
                    })}
                </div>
            case "WitEarnHomeResourcesBtnComp":
                return <div className="WitEarnHomeResources-btnCont">
                    <SecondaryButton buttonText={component?.Props?.buttonText} />
                </div>
            default:
                return <div />
        }

    }
    return (
        <div className="WitEarnHomeResources">
            {sortByOrderAscending(components).map((component, key) => {
                return getComponents(key, component)

            })}
        </div>
    )
}
export default WitEarnHomeResources